import { render, staticRenderFns } from "./AppUpdateBanner.vue?vue&type=template&id=2451cdea&scoped=true&"
import script from "./AppUpdateBanner.vue?vue&type=script&lang=js&"
export * from "./AppUpdateBanner.vue?vue&type=script&lang=js&"
import style0 from "./AppUpdateBanner.vue?vue&type=style&index=0&id=2451cdea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Users/Mac/Desktop/Code/permtang/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2451cdea",
  null
  
)

export default component.exports